import React, { useContext, useEffect, useState } from "react";
import _css from "./TopBar.module.scss";
import { SessionsContext, SideBarNavContext } from "contexts";
import { decodeJwtToken } from "modules/security";
import TopBarBeforeLogin from "./TopBarBeforeLogin";
import TopBarAfterLogin from "./TopBarAfterLogin";
import { HeaderMenuIcon } from "assets";
import { useQuery } from "react-query";
import { GetCurrentUser, GetUserQualities } from "api";
import { useNavigate } from "react-router-dom";
import { UsersIcon, AngleDownIcon, AngleUpIcon } from "@patternfly/react-icons";
import { UserAltIcon } from "@patternfly/react-icons";
import { QUERY_IMAGES } from "services/urls";

const TopBar: React.FC = () => {
  const navigate = useNavigate(); 
  const { sess, setSess } = useContext(SessionsContext);
  const { navData, setNavData } = useContext(SideBarNavContext);
  const [isConnected, setIsConnected] = useState(false);
  const [userData, setUserData] = useState<any>({});
  const [isMobile, setIsMobile] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const accessToken = localStorage.getItem("x-imperso") || localStorage.getItem("x-access-token");

  const { data: userCompleteData } = useQuery(
    ["SEARCH_CURRENT_USER", { access_token: accessToken }],
    GetCurrentUser
  );

  const { data: userQualities = [] } = useQuery(
    ["FETCH_USER_QUALITIES", { access_token: accessToken }],
    GetUserQualities,
    { enabled: !!userCompleteData }
  );

  useEffect(() => {
    if (sess) {
      const decoded = decodeJwtToken(sess);
      setUserData(decoded);
      setIsConnected(true);
    } else setIsConnected(false);
  }, [sess]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSideBar = () => setNavData({ active: !navData.active });

  return (
    <header className={_css.container}>
      <div className={_css.topbar_wrapper}>
        <div className={_css.top_row}>
          <div className={_css.hamburger_area}>
            <img onClick={toggleSideBar} src={HeaderMenuIcon} alt="menu" className={_css.hamburger_icon} />
          </div>

          <div className={_css.logo_area}>
            <img
              src={QUERY_IMAGES + "img/logo_pn5dfx_c_scalew_200.png"}
              alt="bap-logo"
              className={_css.logo_img}
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            />
          </div>

          {isConnected && isMobile && (
             <button className={_css.mobile_toggle} onClick={() => setDropdownOpen(!dropdownOpen)}>
              <span className={_css.mobile_toggle_content}>{userCompleteData?.first_name}</span>

              {localStorage.getItem("x-imperso") && (
                <UserAltIcon
                  size="md"
                  onClick={(e) => {
                    e.stopPropagation(); 
                    localStorage.removeItem("x-imperso");
                    window.location.reload();
                  }}
                  className={_css.icon}
                  title="Quitter l'impersonation"
                  style={{ cursor: "pointer", marginLeft: "0.5rem" }}
                />
              )}

              {dropdownOpen ? (
                <AngleUpIcon className={_css.mobile_icon} />
              ) : (
                <AngleDownIcon className={_css.mobile_icon} />
              )}
            </button>

          )}
        </div>

        <div className={_css.bottom_row}>
          {isConnected
            ? <TopBarAfterLogin userData={userData} setSess={setSess} />
            : <TopBarBeforeLogin />
          }
        </div>
        {isConnected && isMobile && dropdownOpen && (
          <div className={_css.mobile_menu}>
            <div className={_css.qualities}>
              <UsersIcon className={_css.iconQualities}/>
              {userQualities.map((q: any) => (
                <span key={q.id}>{q.name}</span>
              ))}
            </div>

            <div className={_css.hours}>
              <img
                src={QUERY_IMAGES + "img/2-layers.png"}
                alt="hours-icon"
              />
              <span>{userCompleteData?.hours?.toFixed(1)}h</span>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export { TopBar };

